import { render, staticRenderFns } from "./ConfirmLogoutDialog.vue?vue&type=template&id=258df794&"
import script from "./ConfirmLogoutDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmLogoutDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports